var scope_0 = require('/Users/ltmurray/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9321fbbe7772945ae512296af9aacc46.js').default;
var scope_1 = require('/Users/ltmurray/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e65e1a94ab46a50af9c7e1a97c07e22f.js').default;
var scope_2 = require('/Users/ltmurray/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    